import { render, staticRenderFns } from "./BWCommerce.vue?vue&type=template&id=87566110"
import script from "./BWCommerce.vue?vue&type=script&lang=js"
export * from "./BWCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports